import React, { useState, useEffect } from "react";
import { Box, Flex, VStack, Button, Badge, useColorModeValue as mode } from "@chakra-ui/react";
import MessagesLogScreen from "./MessagesLogScreen";
import ScheduledMessagesScreen from "./ScheduledMessagesScreen";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import MessagesSearchScreen from "./MessagesSearchScreen";
import MissedCallMessageScreen from "./MissedCallMessageScreen";
import { getMessageLog, clearMessageLog, getScheduledMessages } from "../redux/actions/messageActions";

const MessageScreen = () => {
  const { scheduled } = useSelector((state) => state.message);
  const dispatch = useDispatch();
  const location = useLocation();
  const [selectedSection, setSelectedSection] = useState(() => {
    let defaultSection = "logs";
    const sectionValue = localStorage.getItem("messagesSection");
    if (sectionValue) {
      defaultSection = sectionValue;
    }
    if (location.state?.fromHeader === true) {
      defaultSection = "logs";
    }
    return defaultSection;
  });

    useEffect(() => {
      // Fetch scheduled messages on mount to update the badge
      dispatch(getScheduledMessages());
    }, [dispatch]);

  const handleSectionChange = (sectionId) => {
    setSelectedSection(sectionId);
    localStorage.setItem("messagesSection", sectionId);

    // When switching to "Message Logs" section, fetch the logs
    if (sectionId === "logs") {
      dispatch(getMessageLog(1));
    }

    // When switching to "Search Messages" section, clear the message log
    if (sectionId === "search") {
      dispatch(clearMessageLog());
    }
  };

  const sections = [
    { id: "logs", name: "Message Logs", component: <MessagesLogScreen /> },
    {
      id: "scheduled",
      name: "Scheduled Messages",
      component: <ScheduledMessagesScreen />,
      badge: scheduled ? scheduled.length : 0
    },
    { id: "search", name: "Search Messages", component: <Box mt={4}><MessagesSearchScreen /></Box> },
    { id: "missed-call", name: "Missed Call", component: <MissedCallMessageScreen /> },
  ];

  const selectedSectionData = sections.find((section) => section.id === selectedSection);

  return (
    <Flex direction={{ base: "column", md: "row" }} minH={{ base: "auto", md: "calc(100vh - 64px)" }} overflow='hidden'>
      {/* Left Navigation */}
      <Box
        w={{ base: "100%", md: "250px" }}
        bg={mode("gray.100", "gray.800")}
        borderRight={{ base: "none", md: "1px" }}
        borderBottom={{ base: "1px", md: "none" }}
        borderColor={mode("gray.200", "gray.700")}
        p={4}
      >
        <VStack
          spacing={2}
          align='stretch'
          direction={{ base: "row", md: "column" }}
          flexWrap={{ base: "wrap", md: "nowrap" }}
        >
          {sections.map((section) => (
            <Button
              key={section.id}
              variant={selectedSection === section.id ? "solid" : "ghost"}
              colorScheme={selectedSection === section.id ? "cyan" : "gray"}
              justifyContent={{ base: "center", md: "flex-start" }}
              flex={{ base: "1 1 auto", md: "1" }}
              minW={{ base: "120px", md: "auto" }}
              onClick={() => handleSectionChange(section.id)}
              minH='40px'
              position="relative"
            >
              {section.name}
              {section.badge !== undefined && (
                <Badge
                  ml='2'
                  py='1'
                  px='2'
                  colorScheme='purple'
                  fontSize='0.8em'
                  rounded='full'
                  position="absolute"
                  right="8px"
                  top="50%"
                  transform="translateY(-50%)"
                >
                  {section.badge}
                </Badge>
              )}
            </Button>
          ))}
        </VStack>
      </Box>

      {/* Main Content */}
      <Box flex='1' overflow='auto'>
        {selectedSectionData?.component}
      </Box>
    </Flex>
  );
};

export default MessageScreen;
